/**
 * サンプルデータ用のプレースホルダ画像
 *
 * 外部URLを踏ませないため、data URI のインラインSVGで完結させる。
 */
export const SAMPLE_MEDIA_IMAGE =
  "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='320' height='320'%3E%3Crect width='320' height='320' fill='%23ECF5F2'/%3E%3Ccircle cx='160' cy='128' r='40' fill='%23CFE3DB'/%3E%3Crect x='72' y='192' width='176' height='14' rx='7' fill='%23CFE3DB'/%3E%3Crect x='104' y='218' width='112' height='14' rx='7' fill='%23DCEAE4'/%3E%3C/svg%3E";

export const SAMPLE_PROFILE_IMAGE =
  "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='96' height='96'%3E%3Crect width='96' height='96' fill='%23ECF5F2'/%3E%3Ccircle cx='48' cy='38' r='16' fill='%23CFE3DB'/%3E%3Cpath d='M16 88c0-17.7 14.3-32 32-32s32 14.3 32 32z' fill='%23CFE3DB'/%3E%3C/svg%3E";
